import { render } from "./RegionSelect.vue?vue&type=template&id=c2f67f54&scoped=true"
import script from "./RegionSelect.vue?vue&type=script&lang=js"
export * from "./RegionSelect.vue?vue&type=script&lang=js"

import "./RegionSelect.vue?vue&type=style&index=0&id=c2f67f54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f67f54"]])

export default __exports__